module.exports = __webpack_public_path__ + "companies-frontend-b21b3468/managed-empty-state-fa5f9e9eae1a901e49e60efc539193a9.png";